import { render, staticRenderFns } from "./expenses-payments.vue?vue&type=template&id=5e933230&scoped=true&"
import script from "./expenses-payments.vue?vue&type=script&lang=js&"
export * from "./expenses-payments.vue?vue&type=script&lang=js&"
import style0 from "./expenses-payments.vue?vue&type=style&index=0&id=5e933230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e933230",
  null
  
)

export default component.exports